/* eslint-disable init-declarations */
/* eslint-disable no-negated-condition */
/* eslint-disable max-statements */
/* eslint-disable no-inline-comments */
/* eslint-disable line-comment-position */
/* eslint-disable default-case */
import { Vertex3 } from '../../../spatial-classes';
import { HorizontalAlignment, VerticalAlignment } from '../../shared.enums';

/**
   * Gets the aligned point from an array of 4 corner points
   * @param corners Array of 4 points [top-left, top-right, bottom-right, bottom-left]
   * @param horizontalAlign Horizontal alignment enum
   * @param verticalAlign Vertical alignment enum
   * @returns The aligned point
   */
export const getAlignedPoint = (
	corners: Vertex3[],
	horizontalAlign: HorizontalAlignment,
	verticalAlign: VerticalAlignment
): Vertex3 => {
	const [topLeft, topRight, bottomRight, bottomLeft] = corners;

	// If both alignments are specific corners, return the appropriate corner
	if (horizontalAlign === HorizontalAlignment.left && verticalAlign === VerticalAlignment.top) {
		return topLeft.clone(); // Position 0
	}
	if (horizontalAlign === HorizontalAlignment.right && verticalAlign === VerticalAlignment.top) {
		return topRight.clone(); // Position 1
	}
	if (horizontalAlign === HorizontalAlignment.right && verticalAlign === VerticalAlignment.bottom) {
		return bottomRight.clone(); // Position 2
	}
	if (horizontalAlign === HorizontalAlignment.left && verticalAlign === VerticalAlignment.bottom) {
		return bottomLeft.clone(); // Position 3
	}

	// Calculate horizontal position
	let x: number, y: number, z: number;

	if (horizontalAlign === HorizontalAlignment.left) {
		// Left edge - average of top-left and bottom-left
		x = (topLeft.x + bottomLeft.x) / 2;
		y = (topLeft.y + bottomLeft.y) / 2;
		z = (topLeft.z + bottomLeft.z) / 2;
	} else if (horizontalAlign === HorizontalAlignment.right) {
		// Right edge - average of top-right and bottom-right
		x = (topRight.x + bottomRight.x) / 2;
		y = (topRight.y + bottomRight.y) / 2;
		z = (topRight.z + bottomRight.z) / 2;
	} else {
		// Center - average of left and right edges
		const leftX = (topLeft.x + bottomLeft.x) / 2;
		const leftY = (topLeft.y + bottomLeft.y) / 2;
		const leftZ = (topLeft.z + bottomLeft.z) / 2;

		const rightX = (topRight.x + bottomRight.x) / 2;
		const rightY = (topRight.y + bottomRight.y) / 2;
		const rightZ = (topRight.z + bottomRight.z) / 2;

		x = (leftX + rightX) / 2;
		y = (leftY + rightY) / 2;
		z = (leftZ + rightZ) / 2;
	}

	// Adjust for vertical alignment
	if (verticalAlign === VerticalAlignment.top) {
		// Top edge - average of top-left and top-right
		const topX = (topLeft.x + topRight.x) / 2;
		const topY = (topLeft.y + topRight.y) / 2;
		const topZ = (topLeft.z + topRight.z) / 2;

		// If horizontal was already calculated, average with top
		if (horizontalAlign !== HorizontalAlignment.center) {
			x = (x + topX) / 2;
			y = (y + topY) / 2;
			z = (z + topZ) / 2;
		} else {
			x = topX;
			y = topY;
			z = topZ;
		}
	} else if (verticalAlign === VerticalAlignment.bottom) {
		// Bottom edge - average of bottom-left and bottom-right
		const bottomX = (bottomLeft.x + bottomRight.x) / 2;
		const bottomY = (bottomLeft.y + bottomRight.y) / 2;
		const bottomZ = (bottomLeft.z + bottomRight.z) / 2;

		// If horizontal was already calculated, average with bottom
		if (horizontalAlign !== HorizontalAlignment.center) {
			x = (x + bottomX) / 2;
			y = (y + bottomY) / 2;
			z = (z + bottomZ) / 2;
		} else {
			x = bottomX;
			y = bottomY;
			z = bottomZ;
		}
	}
	// If verticalAlign is center, we keep the horizontal calculation as-is

	return new Vertex3({ dataIn: { x, y, z }});
};
